import { createAPI } from "../apisServer";

const apiAi = createAPI("aiServer");

const reqS3 = {
	uploadFoto: async function (formData) {
		return apiAi
			.post("ai-server/upload", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((response) => {
				return response.data.url;
			})
			.catch((error) => {
				console.error("[FRONTEND ERROR] Erro no upload:", error);
				throw error;
			});
	},
};

export default reqS3;
